import { z } from "zod";

export enum LaboratorySchemaEnum {
	Laboratory = "Laboratory"
};

export const LaboratorySchema = z.object({
	"@id": z.string(),
	"@type": z.literal("Laboratory"),
	id: z.number(),
	label: z.string(),
}).describe(LaboratorySchemaEnum.Laboratory);

export type Laboratory = z.infer<typeof LaboratorySchema>;
